var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1220_22617",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.85 16.825l3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425-.825 3.575zm3.15-.136l-3.89 2.346a.72.72 0 01-.436.106.791.791 0 01-.395-.147.84.84 0 01-.273-.331.649.649 0 01-.031-.454l1.033-4.417-3.435-2.973a.736.736 0 01-.245-.387.702.702 0 01.028-.428.845.845 0 01.233-.34.808.808 0 01.415-.172l4.533-.396 1.76-4.171a.678.678 0 01.29-.344.82.82 0 01.825 0c.13.074.228.189.292.344l1.76 4.171 4.532.396a.808.808 0 01.416.172c.1.088.178.201.232.34a.702.702 0 01.028.428.736.736 0 01-.245.387l-3.435 2.973 1.033 4.417a.649.649 0 01-.03.454.841.841 0 01-.274.331.791.791 0 01-.395.147.72.72 0 01-.436-.106L12 16.689z",
    fill: "currentColor"
  }))));
}
SvgGrade.displayName = 'Grade';
export default SvgGrade;